import { createStyles, FormLabel, Grid, Link, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import TranslatedMessage from "../translations/TranslatedMessage";
import { routesPaths } from "../../Routes";
import { ExamLanguages, getKeyFromLanguage } from "../../utils/LanguageHelper";
import { TranslationKey } from "../../translations/TranslationKey";
import FormGridCell from "../common/FormGridCell";
import CopyToClipboardButton from "../common/buttons/CopyToClipboardButton";

interface LifeExamSessionLinksProps {
  examSessionId: string;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      gap: `${theme.spacing(0.5)}px`,
    },
    link: {
      display: "flex",
      gap: `${theme.spacing(1)}px`,
      alignItems: "center",
    },
  })
);

const LifeExamSessionLinks: React.FunctionComponent<LifeExamSessionLinksProps> = ({ examSessionId }) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      {ExamLanguages.map((language) => {
        const key = getKeyFromLanguage(language);
        const link = `${window.location.origin}${routesPaths.life(key)}`;

        return (
          <Grid container={true} spacing={1} key={key}>
            <FormGridCell size="half">
              <FormLabel component="legend">
                <Typography variant="body1">
                  <TranslatedMessage id={`common.language.${language.toString().toLowerCase()}` as TranslationKey} />
                </Typography>
              </FormLabel>
            </FormGridCell>
            <FormGridCell size="fill" className={classes.link}>
              <>
                <Link href={link} target="_blank" rel="noopener noreferrer">
                  {link}
                </Link>
                <CopyToClipboardButton content={link} />
              </>
            </FormGridCell>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default LifeExamSessionLinks;
